<!-- A 端 · 外发结算单（线下打款 · 仅登记台账） -->
<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="warning"
      :closable="false"
      show-icon
      title="外发结算单 · 线下打款"
      description="按店×供×账期出账→确认→待线下打款。货款线下付给供；「登记已打款」只勾销台账。出账仅含「合同结算价」快照行（SKU 供货结算价下单写入）；成本回落不可出账。"
    />

    <el-form :inline="true" :model="queryParams" class="-mb-15px" label-width="80px">
      <el-form-item label="单号">
        <el-input v-model="queryParams.no" class="!w-160px" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" class="!w-140px" clearable>
          <el-option label="待确认" value="PENDING_CONFIRM" />
          <el-option label="待打款" value="PENDING_PAY" />
          <el-option label="已打款" value="PAID" />
          <el-option label="无效" value="INVALID" />
        </el-select>
      </el-form-item>
      <el-form-item label="店铺ID">
        <el-input v-model="queryParams.shopId" class="!w-120px" clearable />
      </el-form-item>
      <el-form-item label="供应商ID">
        <el-input v-model="queryParams.supplierId" class="!w-120px" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="success" @click="openGenerate">按账期出账</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="结算单号" prop="no" min-width="170" />
      <el-table-column label="卖货店" min-width="120">
        <template #default="{ row }">{{ row.shopName || row.shopId }}</template>
      </el-table-column>
      <el-table-column label="供应商" min-width="120">
        <template #default="{ row }">{{ row.supplierName || row.supplierId }}</template>
      </el-table-column>
      <el-table-column label="账期" min-width="200">
        <template #default="{ row }">
          {{ formatPeriod(row.periodStart) }} ~ {{ formatPeriod(row.periodEnd) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="{ row }">{{ row.statusName || row.status }}</template>
      </el-table-column>
      <el-table-column label="应付供" width="100">
        <template #default="{ row }">{{ fenToYuan(row.payableAmount) }}</template>
      </el-table-column>
      <el-table-column label="行数" prop="lineCount" width="70" />
      <el-table-column label="操作" width="220" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row.id)">详情</el-button>
          <el-button
            v-if="row.status === 'PENDING_CONFIRM'"
            link
            type="success"
            @click="onConfirm(row.id)"
          >
            确认
          </el-button>
          <el-button
            v-if="row.status === 'PENDING_PAY'"
            link
            type="warning"
            @click="onPay(row)"
          >
            登记线下已打款
          </el-button>
          <el-button
            v-if="row.status === 'PENDING_CONFIRM' || row.status === 'PENDING_PAY'"
            link
            type="danger"
            @click="onInvalidate(row.id)"
          >
            作废
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="loadList"
    />

    <el-dialog v-model="genVisible" title="按账期出账" width="720px" destroy-on-close>
      <el-form label-width="90px">
        <el-form-item label="账期" required>
          <el-date-picker
            v-model="genPeriod"
            type="daterange"
            value-format="YYYY-MM-DD"
            start-placeholder="起"
            end-placeholder="止"
            class="!w-100%"
            @change="onPeriodChange"
          />
        </el-form-item>
        <el-form-item label="可出账组合">
          <div class="w-full">
            <div class="mb-8px text-13px text-[var(--el-text-color-secondary)]">
              先选账期再勾选有往来的店×供；不可手填乱配无关店铺与供应商。
            </div>
            <el-table
              ref="pairTableRef"
              v-loading="pairLoading"
              :data="eligiblePairs"
              row-key="rowKey"
              max-height="320"
              @selection-change="onPairSelect"
            >
              <el-table-column type="selection" width="48" />
              <el-table-column label="卖货店" min-width="140">
                <template #default="{ row }">{{ row.shopName || '#' + row.shopId }}</template>
              </el-table-column>
              <el-table-column label="供应商" min-width="140">
                <template #default="{ row }">{{ row.supplierName || '#' + row.supplierId }}</template>
              </el-table-column>
              <el-table-column label="行数" prop="lineCount" width="70" />
              <el-table-column label="应付供" width="100">
                <template #default="{ row }">¥{{ fenToYuan(row.payableAmount) }}</template>
              </el-table-column>
            </el-table>
            <div v-if="genPeriod && !pairLoading && !eligiblePairs.length" class="mt-8px text-13px text-[var(--el-color-warning)]">
              该账期内无可出账行（需已完成、有结算价快照、且未被占用）。
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="genVisible = false">取消</el-button>
        <el-button type="primary" :loading="genLoading" :disabled="!selectedPairs.length" @click="doGenerate">
          出账（{{ selectedPairs.length }}）
        </el-button>
      </template>
    </el-dialog>

    <el-drawer v-model="detailVisible" title="结算单详情" size="560px">
      <template v-if="detail">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="单号">{{ detail.no }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ detail.statusName }}</el-descriptions-item>
          <el-descriptions-item label="账期">
            {{ formatPeriod(detail.periodStart) }} ~ {{ formatPeriod(detail.periodEnd) }}
          </el-descriptions-item>
          <el-descriptions-item label="应付供">¥{{ fenToYuan(detail.payableAmount) }}</el-descriptions-item>
          <el-descriptions-item label="已登记打款">¥{{ fenToYuan(detail.paidAmount) }}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="detail.items || []" class="mt-16px" size="small">
          <el-table-column label="订单号" prop="orderNo" min-width="140" />
          <el-table-column label="商品" prop="spuName" min-width="120" />
          <el-table-column label="应付" width="90">
            <template #default="{ row }">{{ fenToYuan(row.payableAmount) }}</template>
          </el-table-column>
        </el-table>
      </template>
    </el-drawer>
  </ContentWrap>
</template>

<script setup lang="ts">
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatDate } from '@/utils/formatTime'
import {
  confirmAdminSettle,
  generateAdminSettle,
  getAdminSettle,
  getAdminSettleEligibleGroups,
  getAdminSettlePage,
  invalidateAdminSettle,
  payRecordAdminSettle
} from '@/api/mall/trade/supplierSettle'

defineOptions({ name: 'TradeSupplierSettle' })

const fenToYuan = (fen?: number | null) => ((fen ?? 0) / 100).toFixed(2)
/** 账期只展示日期，兼容毫秒时间戳 / ISO 字符串 */
const formatPeriod = (v?: string | number | Date | null) => {
  if (v == null || v === '') return '-'
  return formatDate(v, 'YYYY-MM-DD') || '-'
}

const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  no: undefined as string | undefined,
  status: undefined as string | undefined,
  shopId: undefined as string | undefined,
  supplierId: undefined as string | undefined
})
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)

const apiParams = () => {
  const p: any = { ...queryParams }
  if (p.shopId) p.shopId = Number(p.shopId)
  else delete p.shopId
  if (p.supplierId) p.supplierId = Number(p.supplierId)
  else delete p.supplierId
  return p
}

const loadList = async () => {
  loading.value = true
  try {
    const data = await getAdminSettlePage(apiParams())
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  loadList()
}
const resetQuery = () => {
  queryParams.no = undefined
  queryParams.status = undefined
  queryParams.shopId = undefined
  queryParams.supplierId = undefined
  handleQuery()
}

const genVisible = ref(false)
const genLoading = ref(false)
const pairLoading = ref(false)
const genPeriod = ref<string[]>()
const eligiblePairs = ref<any[]>([])
const selectedPairs = ref<any[]>([])
const pairTableRef = ref()

const toPeriodBound = (dates: string[]) => ({
  periodStart: `${dates[0]} 00:00:00`,
  periodEnd: `${dates[1]} 23:59:59`
})

const openGenerate = () => {
  genPeriod.value = undefined
  eligiblePairs.value = []
  selectedPairs.value = []
  genVisible.value = true
}

const onPeriodChange = async () => {
  eligiblePairs.value = []
  selectedPairs.value = []
  if (!genPeriod.value || genPeriod.value.length < 2) return
  pairLoading.value = true
  try {
    const rows = (await getAdminSettleEligibleGroups(toPeriodBound(genPeriod.value))) || []
    eligiblePairs.value = rows.map((r: any) => ({
      ...r,
      rowKey: `${r.shopId}_${r.supplierId}`
    }))
    await nextTick()
    // 默认全选有往来组合
    pairTableRef.value?.toggleAllSelection?.()
  } finally {
    pairLoading.value = false
  }
}

const onPairSelect = (rows: any[]) => {
  selectedPairs.value = rows || []
}

const doGenerate = async () => {
  if (!genPeriod.value || genPeriod.value.length < 2) {
    ElMessage.warning('请选择账期')
    return
  }
  if (!selectedPairs.value.length) {
    ElMessage.warning('请勾选要出账的店×供组合')
    return
  }
  genLoading.value = true
  try {
    const bound = toPeriodBound(genPeriod.value)
    const ids = await generateAdminSettle({
      ...bound,
      pairs: selectedPairs.value.map((r) => ({
        shopId: r.shopId,
        supplierId: r.supplierId
      }))
    })
    ElMessage.success(`已生成 ${ids?.length || 0} 张结算单`)
    genVisible.value = false
    loadList()
  } finally {
    genLoading.value = false
  }
}

const detailVisible = ref(false)
const detail = ref<any>()
const openDetail = async (id: number) => {
  detail.value = await getAdminSettle(id)
  detailVisible.value = true
}

const onConfirm = async (id: number) => {
  await ElMessageBox.confirm('确认后进入待打款，是否继续？', '确认结算单')
  await confirmAdminSettle(id)
  ElMessage.success('已确认')
  loadList()
}
const onInvalidate = async (id: number) => {
  await ElMessageBox.confirm('作废后订单行可重新出账，是否继续？', '作废', { type: 'warning' })
  await invalidateAdminSettle(id)
  ElMessage.success('已作废')
  loadList()
}
const onPay = async (row: any) => {
  await ElMessageBox.confirm(
    `确认已线下付给供 ¥${fenToYuan(row.payableAmount)}？本操作仅登记台账，不发起转账、不扣钱包。`,
    '登记线下已打款'
  )
  await payRecordAdminSettle({ id: row.id })
  ElMessage.success('已登记')
  loadList()
}

onMounted(loadList)
</script>
